import { createContext, useState } from "react";

export const NotificationLogContext = createContext({});

export const Provider = (props) => {
    const { children } = props;

    let emptyNotificationLog = {};

    const [notificationLog, setNotificationLog] = useState(emptyNotificationLog);
    const [notificationLogs, setNotificationLogs] = useState([]);
    const [submitted, setSubmitted] = useState(false);
    const [notificationLogDialog, setNotificationLogDialog] = useState(false);

    const resetNotificationLog = () => {
        setNotificationLog(emptyNotificationLog);
    };

    // Make the context object:
    const notificationLogContext = {
        notificationLog,
        resetNotificationLog,
        setNotificationLog,
        notificationLogs,
        setNotificationLogs,
        submitted,
        setSubmitted,
        notificationLogDialog,
        setNotificationLogDialog,
    };

    // pass the value in provider and return
    return <NotificationLogContext.Provider value={notificationLogContext}>{children}</NotificationLogContext.Provider>;
};

export const { Consumer } = NotificationLogContext;
